import { makeJsonApiRequest } from '../base/axios.ts'
import { pick } from 'lodash'
import queryString from 'query-string'

// returns a new object containing only the keys we would like to persist to the server
function _extractServerAttributes(attributes) {
  return pick(attributes, ['name', 'photo_id', 'access_level'])
}

export default {
  loadDatabaseTables: function (databaseId, page, include, visibility) {
    const url = queryString.stringifyUrl({
      url: `/api/v2/databases/${databaseId}/tables`,
      query: {
        include,
        page,
        filters: JSON.stringify({
          visibility,
        }),
      },
    })
    return makeJsonApiRequest({
      method: 'get',
      url,
      requestId: `get-database-tables-${databaseId}`,
    })
  },

  loadTable: function (tableId, include, mode = 'viewing') {
    const url = queryString.stringifyUrl({
      url: `/api/v2/tables/${tableId}`,
      query: {
        include,
        mode,
      },
    })
    return makeJsonApiRequest({
      method: 'get',
      url,
      requestId: `get-table-${tableId}`,
    })
  },

  createTable: function (tableId, attributes) {
    const url = `/api/v2/tables`
    const data = {
      data: {
        type: 'tables',
        attributes: _extractServerAttributes(attributes),
      },
    }
    return makeJsonApiRequest({
      method: 'post',
      url,
      data,
      requestId: `create-table-${tableId}`,
    })
  },

  updateTable: function (tableId, attributes) {
    const data = {
      data: {
        type: 'tables',
        attributes: _extractServerAttributes(attributes),
      },
    }
    return makeJsonApiRequest({
      url: `/api/v2/tables/${tableId}`,
      method: 'patch',
      data,
      requestId: `update-table-${tableId}`,
    })
  },
}
